<template>
  <div>
    <el-button type="primary" size="small" @click="handleEdit()" v-code="61202">
      添加{{ category == 1 ? '零件' : '复合片' }}
    </el-button>
    <el-table :data="list">
      <el-table-column
        align="center"
        label="名称"
        prop="name"
      ></el-table-column>
      <template v-if="category == 1">
        <el-table-column
          align="center"
          label="编码"
          prop="code"
        ></el-table-column>
        <el-table-column
          align="center"
          label="规格"
          prop="specification"
        ></el-table-column>
        <el-table-column
          align="center"
          label="型号"
          prop="model_number"
        ></el-table-column>
        <el-table-column
          align="center"
          label="单位"
          prop="unit"
        ></el-table-column>
      </template>
      <template v-if="category == 2">
        <el-table-column
          align="center"
          label="直径"
          prop="diameter"
        ></el-table-column>
        <el-table-column
          align="center"
          label="齿形"
          prop="tooth_type"
        ></el-table-column>
        <el-table-column
          align="center"
          label="等级"
          prop="grade"
        ></el-table-column
      ></template>
      <el-table-column
        align="center"
        label="数量"
        prop="number"
      ></el-table-column>
      <el-table-column align="center" label="当前价格" prop="price">
        <template slot-scope="scope">
          {{ scope.row.price.toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <el-link
            :type="scope.row.status == 1 ? 'success' : 'warning'"
            :underline="false"
          >
            {{ scope.row.status == 1 ? '启用' : '禁用' }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="120">
        <template slot-scope="scope">
          <el-popconfirm
            v-code="61205"
            title="确认删除该材料吗？"
            @confirm="handleDelete(scope.row.id, scope.$index)"
          >
            <el-link :underline="false" slot="reference" type="danger"
              >删除</el-link
            >
          </el-popconfirm>
          <el-popconfirm
            class="ml-10"
            v-code="61204"
            :title="`确认${scope.row.status == 1 ? '禁用' : '启用'}该材料吗？`"
            @confirm="handleSwitchStatus(scope.row.id, scope.$index)"
          >
            <el-link :underline="false" slot="reference" type="warning">{{
              scope.row.status == 1 ? '禁用' : '启用'
            }}</el-link>
          </el-popconfirm>
          <el-link
            v-code="61203"
            :underline="false"
            class="ml-10"
            type="primary"
            @click="handleEdit(scope.row, scope.$index)"
            >编辑</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <editor
      :model="model"
      :show.sync="formerVisible"
      @callback="callback"
    ></editor>
  </div>
</template>

<script>
import { commodityDelete, commoditySwitchStatus } from '@/service/getData'
import editor from './editor'
export default {
  components: {
    editor,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    category: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      formerVisible: false,
      editIndex: -1,
      model: {},
    }
  },
  methods: {
    handleEdit(item, index) {
      if (!item) {
        this.editIndex = -1
        this.model = {
          category: this.category,
          name: '',
          code: '',
          specification: '',
          model_number: '',
          unit: '',
          chamfering: '',
          diameter: '',
          tooth_type: '',
          grade: '',
          remark: '',
        }
      } else {
        this.model = this.clone(item)
        this.editIndex = index
      }
      this.formerVisible = true
    },
    async handleDelete(id, index) {
      let res = await commodityDelete(id)
      if (res.code == 0) {
        this.list.splice(index, 1)
      }
    },
    async handleSwitchStatus(id, index) {
      let res = await commoditySwitchStatus(id)
      if (res.code == 0) {
        this.$set(this.list, index, res.data)
      }
    },
    callback(data) {
      if (this.editIndex == -1) {
        this.list.unshift(data)
      } else {
        this.$set(this.list, this.editIndex, data)
      }
    },
  },
}
</script>